<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
        <sidebar-link to="/dashboard" :name="$t('sidebar.dashboard')" icon="tim-icons icon-chart-pie-36"/>
        <sidebar-link to="/clocks" :name="$t('sidebar.clocks')" icon="tim-icons icon-watch-time"/>
        <sidebar-link to="/profile" :name="$t('sidebar.userProfile')" icon="tim-icons icon-single-02"/>
        <sidebar-link to="/tickets" :name="$t('sidebar.tickets')" icon="tim-icons icon-chat-33"/>
        <sidebar-link v-if="authorized" to="/employees-settings" :name="$t('sidebar.employeesSettings')" icon="tim-icons icon-settings-gear-63"/>
        <sidebar-link v-if="authorized" to="/employees-clocks" :name="$t('sidebar.employeesClocks')" icon="tim-icons icon-time-alarm"/>
        <sidebar-link v-if="authorized" to="/projects" :name="$t('sidebar.projects')" icon="tim-icons icon-settings"/>
        <sidebar-link v-if="authorized" to="/compensation" :name="$t('sidebar.compensation')" icon="tim-icons icon-money-coins"/>
        <sidebar-link v-if="authorized" to="/safety-documents" :name="$t('sidebar.safetyDocs')" icon="tim-icons icon-alert-circle-exc"/>
        <sidebar-link to="/news" :name="$t('sidebar.news')" icon="tim-icons icon-shape-star"/>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
import {getCookie} from "../../plugins/axios";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },
  data(){return{authorized: false}},
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    getPermission(){
      if(parseInt(getCookie('Type-id')) > 4){
        this.authorized = false;
      }
      else{
        this.authorized = true;
      }
    }
  },
  created() {
    this.getPermission()
  }
};
</script>
